function importTemplateNoCustomizable () {
  return {
    restrict: 'E',
    templateUrl: '/arts/dialogs/import-template-no-customizable/import-template-no-customizable-directive.html?$$REVISION$$'
  }
}

export { importTemplateNoCustomizable }
